import _regeneratorRuntime from "@babel/runtime/regenerator";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import formatStaticUrl from '../utils/formatStaticUrl';
import MediaFrame from '../MediaFrame';
var nullPlayer = {
  type: 'null',
  play: function play() {},
  pause: function pause() {},
  destroy: function destroy() {}
};

var getStaticSrc = function getStaticSrc(filename, config) {
  return "".concat(formatStaticUrl(config)).concat(filename);
};

var cx;
/**
 * The Video component abstracts playback of video from many sources. Powered by
 * `@sie/web-common-video-player` or an object with a compatible interface. For custom
 * player UI a render prop is available.
 *
 * - [MDN html5 video docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video)
 * - [Web Common Video Player Docs](https://github.sie.sony.com/pages/SIE/web-common-toolkit/ui/video-player/)
 *
 * ## Related Components
 * - [Media](../Media/README.md)
 *
 * ## Configuration
 *
 * ```js
 * import { Video } from '@sie/web-common-react-components';
 * import VideoPlayerFactory, { YoutubePlayer, TwitchPlayer } from '@sie/web-common-video-player';
 *
 * const player = new VideoPlayerFactory();
 *
 * player.addImp(YoutubePlayer);
 * player.addImp(TwitchPlayer);
 *
 * Video.configure({ player });
 * ```
 *
 * ## Usage
 * ```jsx
 * // html5
 * <Video src="https://videos.com/somevideo1.mp4" />
 * // youtube
 * <Video src="https://www.youtube.com/watch?v=zeHumSu-_jc" />
 * // twitch
 * <Video src="https://www.twitch.tv/videos/485408510" />
 * ```
 *
 * With custom UI
 * ```jsx
 * <Video
 *    src="https://www.twitch.tv/videos/485408510"
 *    controls={false}
 *    render={(player) => (
 *       <div>
 *         {player.paused
 *             ? <Button onClick={player.play()}>Play</Button>
 *             : <Button onClick={player.pause()}>Pause</Button>
 *         }
 *       </div>
 *    )}
 * />
 * ```
 *
 * ## Props
 */

var Video = /*#__PURE__*/function (_PureComponent) {
  _inherits(Video, _PureComponent);

  var _super = _createSuper(Video);

  function Video(props) {
    var _this;

    _classCallCheck(this, Video);

    if (!Video.player) {
      throw new Error('Video.player is missing: expected video player interface to be set');
    }

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isPlayerReady: false
    });

    var forwardedRef = _this.props.forwardedRef;
    _this.node = forwardedRef || /*#__PURE__*/createRef();
    _this.player = nullPlayer;
    return _this;
  }

  _createClass(Video, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _this$props, src, id, autoplay, controls, onPlay, onPlaying, onPause, onTimeUpdate, onEnded, useStatic, loop, resolvedSrc;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, src = _this$props.src, id = _this$props.id, autoplay = _this$props.autoplay, controls = _this$props.controls, onPlay = _this$props.onPlay, onPlaying = _this$props.onPlaying, onPause = _this$props.onPause, onTimeUpdate = _this$props.onTimeUpdate, onEnded = _this$props.onEnded, useStatic = _this$props.useStatic, loop = _this$props.loop;
                resolvedSrc = useStatic ? getStaticSrc(src, Video.config) : src;
                this.createPromise = Video.player.create({
                  parentEl: this.node.current,
                  src: resolvedSrc,
                  id: id,
                  width: 'auto',
                  height: 'auto',
                  autoplay: autoplay,
                  loop: loop,
                  controls: controls
                }).then(function (player) {
                  _this2.player = player;
                  if (_this2.isUnmounting) return;

                  _this2.setState({
                    isPlayerReady: true
                  });

                  _this2._on('play', onPlay);

                  _this2._on('playing', onPlaying);

                  _this2._on('pause', onPause);

                  _this2._on('timeupdate', onTimeUpdate);

                  _this2._on('ended', onEnded);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      this.isUnmounting = true;

      if (this.player.type === 'null') {
        this.createPromise.then(function () {
          return _this3.player.destroy();
        });
        return;
      }

      this.player.destroy();
    }
  }, {
    key: "_on",
    value: function _on(eventName, cb) {
      if (typeof cb === 'function') {
        this.player.addEventListener(eventName, cb);
      }
    }
  }, {
    key: "addFitAndPlacementClasses",
    value: function addFitAndPlacementClasses(classes) {
      var _this4 = this;

      if (!this.node.current || !this.node.current.firstChild) return;
      classes.split(/\s+/).forEach(function (c) {
        return _this4.node.current.firstChild.classList.add(c);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          render = _this$props2.render,
          dataTrackPlayback = _this$props2.dataTrackPlayback,
          dataTelemetryMeta = _this$props2.dataTelemetryMeta,
          className = _this$props2.className,
          width = _this$props2.width,
          height = _this$props2.height,
          fit = _this$props2.fit,
          place = _this$props2.place,
          aspectRatio = _this$props2.aspectRatio;
      var isPlayerReady = this.state.isPlayerReady;

      var _Video$getClassName = Video.getClassName({
        className: className,
        fit: fit,
        place: place
      }),
          root = _Video$getClassName.root,
          video = _Video$getClassName.video;

      this.addFitAndPlacementClasses(video);
      return /*#__PURE__*/React.createElement(MediaFrame, {
        qa: qa,
        ref: this.node,
        "data-track-playback": dataTrackPlayback,
        "data-telemetry-meta": dataTelemetryMeta,
        width: width,
        height: height,
        className: root,
        aspectRatio: aspectRatio
      }, isPlayerReady && typeof render === 'function' && render(this.player));
    }
  }]);

  return Video;
}(PureComponent);

Video.isVideo = function (_ref) {
  var src = _ref.src,
      type = _ref.type;
  return Video.player && Video.player.isVideo({
    src: src,
    type: type
  });
};

Video.config = {
  npEnvironment: 'e1-np',
  version: 'v0',
  url: 'https://static.{envExceptNp}.playstation.com/images/{version}/'
};

Video.configure = function (_ref2) {
  var player = _ref2.player,
      config = _objectWithoutProperties(_ref2, ["player"]);

  Video.player = player;
  Object.assign(Video.config, config);
};

Video.defaultProps = {
  qa: '',
  id: '',
  render: function render() {},
  dataTrackPlayback: '',
  dataTelemetryMeta: '',
  className: '',
  aspectRatio: '16:9',
  fit: 'cover',
  place: 'center',
  width: undefined,
  height: undefined,
  autoplay: false,
  loop: false,
  controls: true,
  onPlay: function onPlay() {},
  onPlaying: function onPlaying() {},
  onPause: function onPause() {},
  onTimeUpdate: function onTimeUpdate() {},
  onEnded: function onEnded() {},
  forwardedRef: null,
  useStatic: false
};
Video.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Render function to allow custom player UI. The render prop function will receive
   * the instantiated video player object
   */
  render: PropTypes.func,

  /**
   * Property for telemetry tracking of video playback. Indicates playback should be tracked.
   */
  dataTrackPlayback: PropTypes.string,

  /**
   * Property for adding any arbitraty context to the telemetry event
   */
  dataTelemetryMeta: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * event callback to be called when a play event occurs
   */
  onPlay: PropTypes.func,

  /**
   * event callback to be called when a playing event occurs
   */
  onPlaying: PropTypes.func,

  /**
   * event callback to be called when a pause event occurs
   */
  onPause: PropTypes.func,

  /**
   * event callback to be called when a timeUpdate event occurs
   */
  onTimeUpdate: PropTypes.func,

  /**
   * event callback to be called when an ended event occurs
   */
  onEnded: PropTypes.func,
  // html5 attributes

  /**
   * The source url for the video to play
   */
  src: PropTypes.string.isRequired,

  /**
   * The element id to use
   */
  id: PropTypes.string,

  /**
   * The width of the video player
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The height of the video player
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * How to fit the image when aspect ratios are mismatched
   * values generally follow the `background-size` css property
   * [MDN Dos on background-size](https://developer.mozilla.org/en-US/docs/Web/CSS/background-size)
   */
  fit: PropTypes.oneOf(['cover', 'contain', 'fill']),

  /**
   * Strategy for placing the image within it's frame
   */
  place: PropTypes.oneOf(['center', 'right-center', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),

  /**
   * Aspect ratio to restrict the image to. Aspect ratios are defined in
   * the base styles package
   */
  aspectRatio: PropTypes.oneOf([undefined, '1:1', '4:3', '20:9', '16:9', '3:2', '2:3', '3:4', '8:5']),

  /**
   * Whether or not to autoplay the video. Autoplay is generally bad UX and should be avoided
   * it is here for completeness
   */
  autoplay: PropTypes.bool,

  /**
   * Whether or not to loop the video / animation
   */
  loop: PropTypes.bool,

  /**
   * Whether or not to show controls. Youtube currently does not allow hiding it's UI :(.
   */
  controls: PropTypes.bool,

  /**
   * Forwarded ref attached to the image container element
   */
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),

  /**
   * Whether the image is hosted on static.playstation.com
   */
  useStatic: PropTypes.bool
};

Video.getClassName = function (_ref3) {
  var className = _ref3.className,
      place = _ref3.place,
      fit = _ref3.fit;
  return {
    root: cx('psw-video', className),
    video: cx("psw-".concat(place), "psw-l-fit-".concat(fit))
  };
};

Video.useClassNames = function (classNames) {
  Video.classNames = classNames;
};

cx = classNamesFor(Video);
export default Video;